<template>
    <!-- PASSWORD RESET FORM -->
    <div class="container mt-md-5">
        <div class="row">
            <div class="col-md-4 offset-4">
                <form role="form" autocomplete="off" v-on:submit.prevent="handleSubmit">
                    <!-- E-MAIL -->
                    <div class="form-group">
                        <label for="email">{{ $t('email') }}</label>
                        <input
                            class="form-control"
                            type="email"
                            id="email"
                            autocomplete="off"
                            v-model="email"
                            :class="{ 'is-invalid': submitted && !email }"
                        />
                        <div v-show="submitted && !email" class="invalid-feedback">
                            {{ $t('email') }} {{ $t('is_required') }}
                        </div>
                    </div>
                    <div class="alert alert-danger" v-show="error" role="alert">
                        {{ $t(error) }}
                    </div>
                    <!-- BUTTON: SUBMIT -->
                    <button type="submit" class="btn btn-success float-left" :disabled="!email || submitted">
                        {{ $t('send') }}
                    </button>
                    <!-- BUTTON: RETURN TO LOGIN PAGE -->
                    <router-link :to="{ name: 'login' }" class="float-right mt-2">
                        {{ $t('login') }}
                    </router-link>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { resetWebUserPassword } from '@/services/axiosService';

export default {
    data() {
        return {
            email: null,
            error: '',
            submitted: false
        };
    },
    methods: {
        // handle submit click (reset web user password and go to login page)
        async handleSubmit() {
            this.submitted = true;
            if (this.email) {
                try {
                    this.centerConfig = await resetWebUserPassword({ email: this.email });
                    this.$toastr.s(this.$t('email_sent'));
                    this.$router.push('login');
                } catch (error) {
                    this.error = error.response ? error.response.data.message : error.message;
                }
            }
            this.submitted = false;
        }
    }
};
</script>
